import Const from 'constants';

let PlayersSympathy = {
    setPlayersSympathyFromStorage(items) {
        return (dispatch) => {
            dispatch(this.setPlayersSympathy(items, {saveToStorage: false}));
        };
    },

    setPlayersSympathy(items, options = {}) {
        return (dispatch) => {
            const {saveToStorage = true} = options;

            dispatch({
                type: Const.SYMPATHY_SET_PLAYERS,
                items,
            });

            saveToStorage && dispatch(
                this.saveDataToStorage('sympathy', function (state) {
                    const {playersSympathy} = state;
                    return playersSympathy.all();
                }),
            );
        };
    },
};

export default PlayersSympathy;
